<template>
  <div :class="[pc ? 'mw1200' : 'm20']" style="display: flex;justify-content: space-between;margin-bottom: 85px">
    <div :style="{width: pc?'30%':'100%'}">
      <div v-for="i in 2" :key="i" style="margin-bottom: 50px;border-bottom: 1px #B3B3B3 solid;padding-bottom: 5px">
        <template v-if="(current -1) * 2 + i - 1 < $t('home.viewpoints.videos').length">
          <video width="100%" controls="controls" style="object-fit:fill"
                 :src="$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].src"
                 :poster="$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].poster"
          ></video>
          <template v-if="pc">
            <div v-html="$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].name" style="font-size: 18px;color: #7f1f20;margin: 15px 0 3px 0;line-height: 20px"></div>
            <span style="font-size: 16px;font-weight: 600">{{$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].author}}</span>
            <span style="font-size: 16px"> - {{$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].title}}</span>
          </template>
          <template v-else>
            <div v-html="$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].name" style="font-size: 26px;color: #7f1f20;margin: 30px 0 10px 0;line-height: 35px"></div>
            <span style="font-size: 24px;line-height: 16px;font-weight: 600;margin-bottom: 10px">
              {{$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].author}}
            </span>
            <span style="font-size: 24px;line-height: 16px;margin-bottom: 10px"> - {{$t('home.viewpoints.videos')[(current -1) * 2 + i - 1].title}}</span>
          </template>
        </template>
      </div>
      <a-pagination style="margin-top: -30px" v-model="current" :total="$t('home.viewpoints.videos').length" :pageSize="2" :size="pc?'small':''" />
    </div>
    <div v-if="pc" style="padding-left: 40px;width: 66%;border-left: 1px #B3B3B3 solid">
      <img v-if="$t('home.viewpoints.article.author')"
           :src="isEn?`/acnImg/viewpoints/author/${$t('home.viewpoints.article.author')}.png`:`/acnImg/viewpoints/author/c/${$t('home.viewpoints.article.author')}.png`"
           width="100%" />
      <div style="font-style: italic;line-height: 23px;margin: 20px 0 40px 0;font-size: 15px">
        <span style="margin-right: 10px">[{{ $t('home.viewpoints.article.date') }}]</span>{{ $t('home.viewpoints.article.desc') }}
      </div>
      <div style="color: #7f1f20;font-size: 24px">{{ $t('home.viewpoints.article.h') }}</div>
      <div style="margin: 15px 0 25px 0;line-height: 23px;font-size: 15px" v-html="$t('home.viewpoints.article.p')"></div>
      <router-link to="/viewpoints" style="font-size: 15px;border-bottom: 1px solid #808080;font-weight: bold;line-height: 1.2;color: #808080;font-style: italic">{{isEn?'Read more':'阅读更多'}}...</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'viewpoints',
  data () {
    return {
      current: 1
    }
  },
  computed: {
    ...mapGetters(['pc', 'isEn'])
  }
}
</script>
